<script>
    import HandlesActions from '../../mixins/Overview/HandlesActions';
    import updateQueryStringParameter from '../../services/updateQueryStringParameter';
    import Overview from '../Overview.vue';

    export default {
        extends: Overview,

        props: {
            module: {
                type: String,
                required: true,
            },

            section: {
                type: String,
                required: true,
            },
        },

        methods: {
            /**
             * @param {string} url
             *
             * @returns {string}
             */
            parseUrl(url) {
                url = HandlesActions.methods.parseUrl.bind(this)(url);

                url = updateQueryStringParameter(url, 'module', this.module);
                url = updateQueryStringParameter(url, 'section', this.section);

                return url;
            },
        },
    };
</script>
